import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { computed } from "vue";

// The resulting image path is dynamic, so we use the static/content root
// which webpack copies wholesale into the output
const dayGraphicsRootPath = "/content/images/develop/day-graphics/";


export default /*#__PURE__*/_defineComponent({
  __name: 'step-icon',
  props: {
    dayOrPageType: { default: "" },
    isAvailable: { type: Boolean, default: true },
    isCurrent: { type: Boolean, default: false }
  },
  setup(__props: any) {

function getIconPrefix(isCurrent, isAvailable): string {
  if (isCurrent) {
    return "P";
  }
  return isAvailable ? "G" : "B";
}

const props = __props;

const iconPath = computed(() => {
  let icon = "page-type-error.png";

  const day = parseInt(props.dayOrPageType, 10);

  if (!Number.isNaN(day)) {
    const iconColourPrefix = getIconPrefix(props.isCurrent, props.isAvailable);
    icon = `${iconColourPrefix}${day}.svg`;
  }

  if (props.dayOrPageType === "journal") {
    icon = "journal-white.svg";
  }

  if (props.dayOrPageType === "library") {
    icon = "book-green.svg";
  }

  return dayGraphicsRootPath + icon;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: "step-icon",
    src: iconPath.value,
    alt: "step icon"
  }, null, 8, _hoisted_1))
}
}

})